import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ContentContainer from './ContentContainer';

class ImprintContent extends React.Component {
    render() {
        const { texts, dealer } = this.props;
        return (
            <ContentContainer>
                <h1>{texts['title']}</h1>

                {dealer ? (
                    <div className="dealer-imprint">
                        <p>{this.props.dealer.imprint}</p>
                        <hr />
                        <h2>{texts['content.responsible']}</h2>
                    </div>
                ) : null}

                <p>{texts['address']}</p>
                <p>{texts['tel']}</p>
                <p>{texts['fax']}</p>

                <p>
                    <a href={`//${texts['web']}`} target="_blank">
                        {texts['web']}
                    </a>
                </p>
                <p>
                    <a href={`mailto:${texts['mail']}`}>{texts['mail']}</a>
                </p>

                <p>{texts['company']}</p>
                <p>{texts['chief.executive']}</p>
                <p>{texts['commercial.register']}</p>
                <p>{texts['vat']}</p>
                <p>{texts['content']}</p>
                <p>{texts['agency']}</p>

                <h2>{texts['legal.notices.title']}</h2>
                <p>{texts['legal.notices.copy']}</p>

                <h2>{texts['ga.title']}</h2>
                <p>{texts['ga.copy']}</p>
            </ContentContainer>
        );
    }
}

function mapStateToProps(state) {
    return {
        texts: {
            title: state.app.texts['imprint.title'],
            address: state.app.texts['imprint.address'],
            tel: state.app.texts['imprint.tel'],
            fax: state.app.texts['imprint.fax'],
            web: state.app.texts['imprint.web'],
            mail: state.app.texts['imprint.mail'],
            company: state.app.texts['imprint.company'],
            'chief.executive': state.app.texts['imprint.chief.executive'],
            'commercial.register': state.app.texts['imprint.commercial.register'],
            vat: state.app.texts['imprint.vat'],
            content: state.app.texts['imprint.content'],
            agency: state.app.texts['imprint.agency'],
            'legal.notices.title': state.app.texts['imprint.legal.notices.title'],
            'legal.notices.copy': state.app.texts['imprint.legal.notices.copy'],
            'ga.title': state.app.texts['imprint.ga.title'],
            'ga.copy': state.app.texts['imprint.ga.copy'],
            'content.responsible': state.app.texts['imprint.content.responsible'],
            'content.responsible_schneider': state.app.texts['imprint.content.responsible_schneider'],
        },
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImprintContent);
